import * as React from "react";
import CtaButton from "../cta-button/cta-button";
import classNames from "classnames";
import Title from "~/components/title/title";
import ResponsiveImage from "../responsive-image/responsive-image";
import WrapperLink from "../wrapper-link/wrapper-link";
import { ImageTextCtaReusableProps } from "../image-text-cta/image-text-cta";
import ArrowLink from "../arrow-link/arrow-link";
import ContentSection from "../content-section/content-section";

export interface FullWidthImageTextCtaProps extends ImageTextCtaReusableProps {
    isTitleH1?: boolean;
    overlayDisabled?: boolean;
    extendStylingForNextModuleOverlap?: boolean;
    anchorId?: string;
}

const FullWidthImageTextCta = ({
    imageSrc,
    imageAltText,
    isTitleH1,
    title,
    richText,
    ctaLink,
    ctaUrl,
    ctaTarget,
    showCtaAsLink,
    useCtaAsImageLink,
    overlayDisabled,
    extendStylingForNextModuleOverlap,
    ...props
}: FullWidthImageTextCtaProps) => {
    const hasContent = title || richText || (ctaLink && !useCtaAsImageLink);
    const baseClass = "full-width-image-text-cta";
    const componentClasses = classNames(baseClass, {
        [`${baseClass}--is-next-module-overlapping`]: extendStylingForNextModuleOverlap,
        [`${baseClass}--is-overlay-disabled`]: overlayDisabled,
        [`${baseClass}--has-no-content`]: !hasContent
    });

    return (
        <ContentSection className={componentClasses} {...props}>
            <WrapperLink
                linkClassName={`${baseClass}-wrapper-link`}
                href={useCtaAsImageLink ? ctaUrl : undefined}
                target={ctaTarget}
            >
                <div className={`${baseClass}__inner horizontal-align-center text-align-center`}>
                    {imageSrc && (
                        <ResponsiveImage
                            className={`${baseClass}__image`}
                            defaultSize={1366}
                            srcSetSizes={[320, 375, 480, 640, 768, 1024, 1280, 1366]}
                            sizes="(max-width: 1365px) 100vw, 1366px"
                            alt={imageAltText}
                            srcUrl={imageSrc}
                        />
                    )}

                    {hasContent && (
                        <div className={`${baseClass}__content-wrapper`}>
                            {title && <Title title={title} isTitleH1={isTitleH1} />}
                            {richText && (
                                <div
                                    className={`${baseClass}__rich-text content-rich-text`}
                                    dangerouslySetInnerHTML={{ __html: richText }}
                                />
                            )}
                            {ctaLink && !useCtaAsImageLink && (
                                <>
                                    {showCtaAsLink ? (
                                        <ArrowLink className={`${baseClass}__link`} link={ctaLink} />
                                    ) : (
                                        <CtaButton
                                            className={`${baseClass}__btn theme-bg-white theme-color-black`}
                                            link={ctaLink}
                                            isLarge
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    )}
                </div>
            </WrapperLink>
        </ContentSection>
    );
};

export default FullWidthImageTextCta;
